import { ChecklistFieldAccessoryOptions } from '../../../models/Checklist'

export function isAllowed(field: ChecklistFieldAccessoryOptions): boolean {
  return field && field !== 'not_allowed'
}

export function isMandatory(field: ChecklistFieldAccessoryOptions): boolean {
  return field === 'mandatory'
}
